import "bootstrap/dist/js/bootstrap.bundle.min.js"
import AOS from "aos"
import "aos/dist/aos.css"

// Το template είναι γεμάτο data-aos attributes αλλά ΔΕΝ είχε το AOS στις
// dependencies — δηλαδή όλα τα scroll animations ήταν νεκρά. Τα ενεργοποιούμε.
export const onClientEntry = () => {
  AOS.init({
    duration: 800,
    easing: "ease-out-cubic",
    once: true,
    offset: 60,
    // Σεβασμός στο prefers-reduced-motion του χρήστη.
    disable: () =>
      window.matchMedia("(prefers-reduced-motion: reduce)").matches,
  })
}

// Μετά από client-side navigation το DOM αλλάζει· το AOS πρέπει να ξαναμετρήσει
// θέσεις, αλλιώς τα στοιχεία της νέας σελίδας μένουν αόρατα (opacity: 0).
export const onRouteUpdate = () => {
  AOS.refreshHard()
}
